import React from "react";
import logo from "../../assets/images/Newsletter/images/cslogo1.png";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/june-2025/banner.jpg";
import sushil from "../../assets/images/Newsletter/images/shushil-Gujrathi.png";
import Dignostics from "../../assets/images/Newsletter/june-2025/Diagnostic-Testing-2.webp";
import diamond from "../../assets/images/Newsletter/june-2025/diamond-jewellery.webp";
import malls from "../../assets/images/Newsletter/june-2025/mall_2_.png";
import bank from "../../assets/images/Newsletter/june-2025/leading_Banks_of_Egypt.jpg";
import hospitalityCompany from "../../assets/images/Newsletter/june-2025/Hospitality-Management-Degrees-What-Can-They-Do-For-Me.jpg";
import AgentforceDubaiEvent from "../../assets/images/Newsletter/june-2025/Agentforce-Dubai-Event.jpg";
import EgyptNetcoreEvent from "../../assets/images/Newsletter/june-2025/Egypt-Netcore-Event.jpg";
import salesforceVisit from "../../assets/images/Newsletter/june-2025/salesforce_visit.jpg";
import vishnu from "../../assets/images/Newsletter/june-2025/vishnu.jpg";
import BusinessQuote2 from "../../assets/images/Newsletter/june-2025/gettyimages-1052306510.jpg";
import sanika from "../../assets/images/Newsletter/june-2025/sanika.jpg";
import vaibhav from "../../assets/images/Newsletter/june-2025/vaibhav.jpg";
import joinees from "../../assets/images/Newsletter/june-2025/joinee.png";
import Workshop from "../../assets/images/Newsletter/june-2025/Workshop.jpg";
import BirthdayCelebration from "../../assets/images/Newsletter/june-2025/birthday.jpg";
import daji from "../../assets/images/Newsletter/june-2025/Daaji.jpg";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import BusinessQuoteOne from "../../assets/images/Newsletter/june-2025/Larry.jpg";
import leadership from "../../assets/images/Newsletter/june-2025/leadership.jpg";
import sachin from "../../assets/images/Newsletter/june-2025/sachin.jpg"

const June = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER June-2025</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sushil}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear All,
                                              <br />
                                              <br />
                                              As we close the first quarter of
                                              2025, I want to take a moment to
                                              reflect on the strong start we’ve
                                              had to the year—and to thank each
                                              of you for your unwavering
                                              commitment to excellence.
                                              <br />
                                              <br />
                                              The past few months have
                                              reaffirmed my belief in the power
                                              of aligned execution,
                                              collaborative energy, and
                                              human-centred innovation. We set
                                              out with bold aspirations, and
                                              already we’re seeing tangible
                                              outcomes: new client wins,
                                              expanded mandates from existing
                                              partners, and successful
                                              deliveries that underscore our
                                              credibility and impact.
                                              <br />
                                              <br />
                                              <strong
                                                style={{ fontSize: "larger" }}
                                              >
                                                Q1 was marked by momentum in
                                                three key areas:
                                              </strong>
                                              <br />
                                              <strong>
                                                • Client-Centric Growth:{" "}
                                              </strong>{" "}
                                              We deepened relationships with
                                              strategic clients and stepped into
                                              more advisory-led roles,
                                              showcasing the value of being
                                              proactive problem-solvers and
                                              transformation partners.
                                              <br />
                                              <strong>
                                                • Innovation at Speed:{" "}
                                              </strong>
                                              From early AI-led solution
                                              accelerators to pilot programs
                                              across industries, we’ve begun
                                              converting experimentation into
                                              enterprise-grade delivery.
                                              <br />
                                              <strong>
                                                • People-First Culture:{" "}
                                              </strong>{" "}
                                              Our focus on learning, wellness,
                                              and empowerment is fostering a
                                              culture of ownership, agility, and
                                              psychological safety—paving the
                                              way for long-term performance.
                                              <br />
                                              <br />
                                              This quarter has not been without
                                              its share of challenges, but what
                                              stood out was how we
                                              responded—with resilience,
                                              clarity, and a shared belief in
                                              delivering impact. That mindset
                                              will continue to serve us well as
                                              we scale our ambition.
                                              <br />
                                              <br />
                                              Looking ahead, our priorities
                                              remain grounded in our strategic
                                              intent:
                                              <br />
                                              <strong>
                                                • Accelerate high-value growth.{" "}
                                              </strong>
                                              <br />
                                              <strong>
                                                • Deliver with speed and
                                                precision.{" "}
                                              </strong>
                                              <br />
                                              <strong>
                                                • Reimagine solutions with AI at
                                                the core.{" "}
                                              </strong>
                                              <br />
                                              <strong>
                                                • Create an environment where
                                                people thrive.{" "}
                                              </strong>
                                              <br />
                                              <br />
                                              The journey ahead is exciting—and
                                              I am confident that we are
                                              building a company that not only
                                              grows, but grows meaningfully. Let
                                              us continue to lead with purpose,
                                              act with intent, and deliver with
                                              pride.
                                              <br />
                                              <br />
                                              <strong>Sushil Gujrathi</strong>
                                              <br />
                                              <strong>
                                                CEO and Co-Founder
                                              </strong>
                                              <br />
                                              <strong>
                                                Comsense Technologies
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Won Deals
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  CDP implementation with
                                                  Netcore for one of the Leading
                                                  Diagnostic Company in India
                                                
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Dignostics}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense is proud to announce
                                                that we won a deal with a
                                                Leading Diagnostic Company in
                                                India, which has an
                                                international presence with
                                                4000+ collection centres, for
                                                CDP (Customer data unification
                                                solution) implementation with
                                                Netcore.
                                                <br />
                                                As a part of the deal, we are
                                                building a Single View of
                                                Customer (SVOC) that provides a
                                                comprehensive picture of each
                                                patient - including their
                                                medical history, family
                                                associations, frequency of
                                                check-ups, illness patterns, and
                                                last visit details. Using this
                                                unified view, we will help our
                                                client segment patients to
                                                deliver highly personalized,
                                                automated campaigns based on
                                                their test reports.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  <strong>
                                                    SalesForce full stack
                                                    implementation for one of
                                                    the most Dominant Jewellery
                                                    Brands in India{" "}
                                                  </strong>
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={diamond}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense won a deal with a
                                                leading and dominant diamond &
                                                platinum jewellery brand of
                                                India with 90+ stores across 40
                                                cities in India to implement the
                                                full Salesforce stack, including
                                                Data Cloud, Marketing Cloud,
                                                Tableau, Sales, Service, and
                                                Agent Force. By unifying
                                                customer data into a single
                                                source of truth, our team will
                                                enable truly personalized,
                                                seamless shopping experiences
                                                for the end customer. We will
                                                also be building powerful
                                                management-level dashboards to
                                                help the business make smarter,
                                                faster decisions and empower
                                                sales and service teams to
                                                deliver exceptional customer
                                                experiences in stores.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  MarTech Stack Evaluation for
                                                  one of the leading Banks of
                                                  Egypt
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={bank}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense is proud to engage with
                                                one of the leading Banks of
                                                Egypt to support them to build
                                                framework for evaluation,
                                                assessment and selection of
                                                right MarTech platform sufficing
                                                their aspired needs towards the
                                                Digital Marketing
                                                Transformation.
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Driving SFMC Adoption &
                                                  WhatsApp Integration for a
                                                  Leading Premium Mall in India
                                                  {" "}
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={malls}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are helping a leading premium mall in India, a major player in the retail industry, with adoption audits for SFMC. Our audits aim to help the client team understand the adoption rate and how to fully use the features of SFMC to its full potential. In addition to the audit, we have also unified WhatsApp messaging from Salesforce Marketing Cloud to Data Cloud for multiple WhatsApp Business Account numbers. 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Marketing Campaigns for one of
                                                  South Asias largest
                                                  hospitality company 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={hospitalityCompany}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are excited to run Email and WhatsApp campaigns for a premium hospitality company that has presence in 14+ countries with over 400 hotels. These campaigns are focused on offers and special offers for one of their loyalty cardholders. Additionally, we also run 9 web journeys for their website, which include web pop-ups and price highlights among others.   
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Client Testimonials */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Client Testimonials
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                              border:
                                                "2px solid rgb(210, 210, 210)",
                                              padding: "20px",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Working with Comsense has been a
                                                great experience, and your
                                                dedication truly made things
                                                smoother and more effective.
                                                From segmentation and campaign
                                                execution to managing
                                                last-minute tasks and reports —
                                                you guys have always been
                                                reliable and on point.
                                                <br />A special shoutout to Neha
                                                & Omkar for being my go-to for
                                                anything CRM-related your
                                                constant support never went
                                                unnoticed. Shubham, thank you
                                                for always being there when I
                                                need help with segmentation,
                                                reporting, and managing
                                                short-notice tasks. Your
                                                collaboration made things easier
                                                and more effective you always
                                                delivered, even under pressure.
                                                And Tushar, your support has
                                                been truly exceptional. Whether
                                                it was a last-minute request,
                                                any critical campaign execution,
                                                or CLM season launch, you were
                                                always quick to respond and
                                                resolve things efficiently. I’ve
                                                always felt confident reaching
                                                out to you, knowing that you’d
                                                provide a solution without
                                                delay. You went above and beyond
                                                by supporting me and delivering
                                                all tasks on time, even while
                                                handling a family medical
                                                emergency from the hospital
                                                truly admirable and appreciated.
                                                Your calm and helpful attitude,
                                                even under pressure, made a huge
                                                difference and helped things run
                                                smoothly on multiple occasions.
                                                It’s been a pleasure working
                                                with all of you. Thank you again
                                                for being such a strong and
                                                dependable team. Wishing you all
                                                continued success ahead!
                                              </p>
                                              {/* <br> */}
                                              {/* <p>Overall, the exceptional quality of service and support from Comsense has made a
                            significant
                            positive impact on our operations. We highly recommend their services and look forward
                            to
                            continued collaboration.</p> */}
                                              {/* <br> */}
                                              <strong>
                                                <i>
                                                  - Amit Kumar, CRM Team Lead{" "}
                                                </i>
                                              </strong>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          {/* <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline lable=content>
                          <strong>Umang and Team, Congratulations on a successful project handover!!</strong>
                          <p>Shout out to the Data Cloud implementation team especially! , @Vishnu Kamath
                            @Ranjith Rajmohan @Shubham Bhosekar and @Niharika Vashishtha - great work overall
                            taking this to closure, I know this was not easy to begin with.. we faced several
                            blockers right from discovery. I appreciate the team's perseverance throughout several
                            rounds of corrections & re-work. The team has run 10+ unification rules and validated
                            cases by region and by category (B2B and Individual owners). @Vishnu Kamath, @Ranjith
                            Rajmohan -
                            Your experience with Python and data helped here to expedite the transformation and
                            cleanup logic
                            for large data sets run analysis for the spread, and point out the gaps.</p>
                          <strong><i>- Anusha Vrushabendraswamy | Lead Technical Architect, Strategic Accounts
                              Excellence | Salesforce</i></strong>
                        </multiline>
                      </td> */}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Business Quote 1
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Always deliver more
                                                        than expected”{" "}
                                                      </i>
                                                      <br />
                                                      <br />
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Larry Page,
                                                        </span>{" "}
                                                        Co-founder of Google
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuoteOne}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*  */}

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Business News/Events
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Salesforce Agentforce Event, Dubai – An event of connections and deep insights  
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={AgentforceDubaiEvent}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Our CEO, Sushil Gujrathi and Head of Business, Visnu Kamath, attended the highly successful Agentforce World Tour Dubai in May. The event not only gave them a chance to connect with passionate Salesforce professionals across the globe but also provided valuable insights that will aid us in implementing Salesforce’s solutions. Lively sessions and peer networking created a very inspirational environment throughout. 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
Our CEO, Sushil Gujrathi, attended Netcore’s MarTech Global Summit in Cairo, Egpyt 
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EgyptNetcoreEvent}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
Netcore’s MarTech Global Summit in Cairo was a phenomenal event to attend. The event focused on and took a deep dive into how AI is reshaping every stage of customer engagement. The event was attended by our CEO, Sushil Gujrathi, whose favorite parts of the event were the discussions around zero-guesswork marketing and smarter ROI-driven journeys as well as strategies that weren’t just theoretical but really working in 2025. 
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Team Attended Agent Force
                                            World Tour – Mumbai
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={salesforceVisit}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense’s leadership team, along
                                              with the BU Heads, attended the
                                              Agent Force event hosted by
                                              Salesforce in BKC, Mumbai. The
                                              event included expert-led sessions
                                              and the latest product demos for
                                              various industries. The
                                              Chairperson & CEO of Salesforce
                                              India, Arundhati Bhattacharya,
                                              shared insights on how leadership
                                              and adaptability are at the heart
                                              of navigating this fast-changing
                                              digital landscape. A conversation
                                              between Arun Kumar Parameswaran
                                              (EVP, Salesforce) and Sania Mirza
                                              was engaging, where Sania spoke
                                              about resilience, reinvention, and
                                              high-performance - values that
                                              apply not just in sports, but
                                              across every profession. It was a
                                              great learning and networking
                                              opportunity for our team.
                                              <br />
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Leadership Quarterly Meet
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={leadership}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Quarterly offsite of the
                                              leadership team was successfully
                                              organized and completed with deep
                                              conversations, insights, debates,
                                              and disagreements, but all with
                                              high energy, ideas, and laughter.
                                              The offsite closed with something
                                              simple yet powerful – a process to
                                              evaluate ideas, work on them, and
                                              know when to stop. The base idea
                                              was “Starting something new only
                                              works if you stop something else
                                              of equal or more magnitude.” Thus
                                              came our mantra for the coming
                                              quarters – Start. Stop. Continue
                                              We are hoping to walk into future
                                              quarters with more clarity and
                                              alignment.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
We are thrilled to welcome Sachin Itkar onboard as a Strategic Advisor at Comsense Technologies!
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "250px",
                                              }}
                                              src={sachin}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
 
Sachin brings with him a wealth of global experience spanning policy advisory, international partnerships, healthcare innovation, and enterprise scaling. 

As a prominent member of the Strategic Foresight Group, an influential global think tank, and Vice President at the Maharashtra Economic Development Council, he has worked closely with governments and corporate leaders across continents to drive meaningful, responsible growth.
 
At Comsense, he will lead the global expansion of our Zero Capex Global Capability Center (GCC) model, helping enterprises across the US, Europe, and the Middle East build future-ready offshore teams in AI, data, and digital engineering, without the usual complexities or upfront costs.

Welcome to the Comsense family, Sachin! We’re excited to co-create the future with you!
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*     <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>

              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* <layout label="1/1 content">
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tbody>
    <tr>
      <td align=center>
        <table align=center border=0 cellpadding=0 cellspacing=0>
          <tbody>
            <tr>
              <td width=600 align=center>
                <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
                  <tbody>
                    <tr>
                      <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                        <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                          <tbody>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center width=580
                                style="font-family:Century gothic,arial,sans-serif;font-size:24px;color:#4a4a4a;font-weight:100;line-height:30px">
                                <singleline label=title>Case Studies </singleline>
                              </td>
                            </tr>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td align=center>
                                <table width=40 bgcolor=#FF0000 style=border-radius:10px border=0 cellpadding=0
                                  cellspacing=0>
                                  <tbody>
                                    <tr>
                                      <td height=5 style=line-height:0;font-size:0px>&nbsp;</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <br>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td width=580 align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:18px;color:red;line-height:28px;font-weight:700;text-align:center">
                                Comsense Quarterly Awards
                              </td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td width=580 align=center style=line-height:0>
                                <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                                  src=images/awards.png alt=img width=100% height=auto>
                              </td>
                            </tr>
                            <tr>
                              <td height=10></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Since we were unable to organize our Quarterly Award
                                  Ceremony in our previous quarter, we made it up by awarding people from two
                                  previous quarters together.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Rookie (Rising Star) Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Comsense is always proud of its young and fresh team
                                  members who excel very early in their careers. This time our Rising star awards
                                  were given to <strong>Abhishek Sontakke, Sneha Kshirsagar, and Girish
                                    Sahare</strong> for their excellent performances in such early days of their
                                  span at Comsense.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Star Performer Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Our best performers of the last two quarters were
                                  <strong>Anant Kadam, Shubham Chordia, and Soumy Dubey.</strong> They have gone
                                  beyond their roles to ensure Comsense’s success and thus rightly deserve the
                                  award. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Ace Contributors:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Rakhi Ankar</strong> was awarded the Ace
                                  Contributor award for being excellent in all roles and responsibilities given to
                                  her.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Innovation Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Suvaknata Rawat</strong> was awarded the
                                  innovation award for showcasing an excellent innovative approach towards problem
                                  solving and solutioning. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
    </layout> */}
          <layout label="1/1 content">
            {/* <table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table align=center border=0 cellpadding=0 cellspacing=0>
        <tr>
          <td width=600 align=center>
            <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
              <tr>
                <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                  <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td width=580 align=center style=line-height:0>
                        <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                          src=images/five-years.png alt=img width=100% height=auto>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline label=content>
                          We were thrilled to honor Vishnu Kamath and Neerajkumar Gogavale with the Long Service
                          Award as they both completed 5 years with Comsense. We are thankful for their faith and
                          belief in the spirit of Comsense and wish them a long, fruitful journey ahead with us!
                          <br><br>
                        </multiline>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table> */}
          </layout>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 24,
                                    color: "#4a4a4a",
                                    fontWeight: 100,
                                    lineHeight: "30px",
                                  }}
                                >
                                  <singleline label="title">
                                    Tech Trends
                                  </singleline>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    width={40}
                                    bgcolor="#FF0000"
                                    style={{ borderRadius: 10 }}
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          height={5}
                                          style={{ lineHeight: 0, fontSize: 0 }}
                                        >
                                          &nbsp;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  width={580}
                                  align="center"
                                  style={{
                                    fontFamily: "Open sans,arial,sans-serif",
                                    fontSize: 18,
                                    color: "red",
                                    lineHeight: "28px",
                                    fontWeight: 700,
                                    textAlign: "center",
                                  }}
                                >
                                  The AI Rat Race: Why Everyone Suddenly Wants
                                  an AI Strategy
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={vishnu}
                                            width={150}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: "5px solid #eaecf0",
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={120} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="left"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      color: "#000",
                                                      fontFamily:
                                                        "Century Gothic",
                                                      fontSize: 14,
                                                      fontStyle: "normal",
                                                      fontWeight: 400,
                                                      lineHeight: "normal",
                                                      marginBottom: 0,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "#000",
                                                        fontFamily:
                                                          "Century Gothic",
                                                        fontSize: 14,
                                                        fontStyle: "normal",
                                                        fontWeight: 700,
                                                        lineHeight: "normal",
                                                      }}
                                                    >
                                                      - By Vishnu Kamath, Data
                                                      Science BU HEAD
                                                    </span>
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={10} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          {/* Tech Trends */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              There’s a bit of a mad rush
                                              happening across industries right
                                              now — everyone wants an AI play.
                                              Whether it's BFSI, retail,
                                              automotive, or even sectors that
                                              were traditionally slower to adopt
                                              tech, businesses are scrambling to
                                              figure out how AI can fit into
                                              their strategy… or rather, how
                                              they can build a strategy around
                                              AI.
                                              <br />
                                              <br />
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                What’s driving this? The growing
                                                realization that AI is no longer
                                                something futuristic or “nice to
                                                have.” It’s here. It’s real. And
                                                if used right, it can be a
                                                game-changer. Companies are
                                                waking up to the fact that
                                                intelligent automation and
                                                AI-powered insights can help
                                                them move faster, make smarter
                                                decisions, and serve customers
                                                better.
                                                <br />
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We’re seeing this shift up
                                                close. For example, one of our
                                                BFSI clients is working on a
                                                pretty solid AI model that reads
                                                and interprets complex
                                                regulatory documents — something
                                                that usually takes weeks — and
                                                helps them ensure compliance
                                                before launching new products.
                                                It’s cutting down time, effort,
                                                and risk in a space that can't
                                                afford delays or mistakes.
                                              </p>
                                              {/* <br> */}
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                And in retail, AI shopping
                                                assistants are becoming a quiet
                                                revolution — helping customers
                                                find exactly what they’re
                                                looking for, personalizing the
                                                experience, and driving better
                                                conversions.
                                              </p>
                                              {/* <strong>Steady Cash Flow:</strong> Repeat orders from existing customers ensure
                                  a consistent cash flow, aiding in financial planning and stability. With
                                  predictable revenue streams, businesses can manage their finances more
                                  effectively and invest confidently in growth initiatives. Research indicates
                                  that existing customers spend 67% more on average than new customers (<a
                                    href=https://www.business.com/articles/returning-customers-spend-67-more-than-new-customers-keep-your-customers-coming-back-with-a-recurring-revenue-sales-model/>source</a>). */}
                                              {/* <br> */}
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Truth is, everyone’s
                                                experimenting. But not everyone
                                                is doing it right. As AI becomes
                                                mainstream, the real
                                                differentiator will be how
                                                thoughtfully it's implemented —
                                                and how well it aligns with
                                                business goals.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                This is where we’re partnering
                                                with organizations — not just to
                                                tick the “AI” box, but to truly
                                                unlock its value in a way that
                                                makes sense for them.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>
              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td style="border:2px solid #d2d2d2" align=center>
                  <table class=table-inner width=500 border=0 align=center cellpadding=0 cellspacing=0>
                    <tr>
                      <td height=20></td>
                    </tr>
                    <tr>
                      <td align=center>
                        <table class=table-full width=375 border=0 align=left cellpadding=0 cellspacing=0>
                          <tr>
                            <td
                              style="font-family:Open sans,arial,sans-serif;font-size:16px;color:#9b9b9b;line-height:28px;font-weight:600">
                              <multiline label=quote><i>“Winning as a team is better than anything else. It’s
                                  great to share success”</i>
                                <br>
                                <span
                                  style="color:#9b9b9b;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">
                                  <span
                                    style="color:#000;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">-
                                    Jim Harbaugh, </span> American Football Coach</span>
                              </multiline>
                            </td>
                          </tr>
                        </table>
                        <table width=25 border=0 cellpadding=0 cellspacing=0 align=left>
                          <tr>
                            <td height=10></td>
                          </tr>
                        </table>
                        <table class=table-full width=100 border=0 align=right cellpadding=0 cellspacing=0>
                          <tr>
                            <td align=center style=line-height:0>
                              <img src=images/Jim-Harbaugh.jpg alt=img width=100
                                style=display:block;line-height:0;font-size:0px;border:0 editable label=image>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* Business Quote 2 */}
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Business Quote
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Business opportunities
                                                        are like buses, there’s
                                                        always another one
                                                        coming”{" "}
                                                      </i>
                                                      <br />
                                                      <br />
                                                      <br />
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Richard Branson,
                                                        </span>{" "}
                                                        Businessman, Co-Founder
                                                        of Virgin Group
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuote2}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Associate Speak */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Associates Speak
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                            }}
                                                          >
                                                            <img
                                                              src={sanika}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              My experience at
                                                              Comsense
                                                              Technologies has
                                                              been incredibly
                                                              rewarding. I’ve
                                                              had the
                                                              opportunity to
                                                              work for one of
                                                              the Big Tech
                                                              companies, which
                                                              helped me gain
                                                              valuable exposure
                                                              and enhanced both
                                                              my professional
                                                              and interpersonal
                                                              skills. With a
                                                              genuine culture of
                                                              support and
                                                              collaboration,
                                                              I’ve always felt
                                                              empowered to share
                                                              ideas, learn from
                                                              others, and take
                                                              on challenges that
                                                              help me grow.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Sanika
                                                                  Kadam,
                                                                </strong>{" "}
                                                                Marketing
                                                                Research
                                                                Specialist
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner desktop-view"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              My journey at
                                                              Comsense
                                                              Technologies has
                                                              been nothing short
                                                              of transformative.
                                                              The company
                                                              fosters a culture
                                                              of continuous
                                                              learning and
                                                              support, where I
                                                              had the
                                                              opportunity to
                                                              explore new
                                                              technologies and
                                                              grow both
                                                              technically and
                                                              personally. The
                                                              guidance and
                                                              encouragement from
                                                              my seniors and
                                                              manager played a
                                                              crucial role in
                                                              building my
                                                              confidence and
                                                              skills. I truly
                                                              value the
                                                              friendships I have
                                                              formed and the
                                                              collaborative
                                                              spirit that made
                                                              every day a
                                                              rewarding
                                                              experience.
                                                              Comsense isn’t
                                                              just a
                                                              workplace—it’s a
                                                              place where people
                                                              and potential are
                                                              nurtured.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Vaibhav
                                                                  Markale,
                                                                </strong>
                                                                , Trainee
                                                                Software
                                                                Engineer{" "}
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={30} />
                                                        </tr>
                                                        <tr>
                                                          <td height={5} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={vaibhav}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner mobile-responsive"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              // src={rohit}
                                                              src={vaibhav}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Working at
                                                              Comsense has been
                                                              an incredible
                                                              journey of growth,
                                                              both in my career
                                                              and personally. As
                                                              an Salesforce
                                                              Marketing Cloud
                                                              Personalization
                                                              expert, I’ve had
                                                              the opportunity to
                                                              work with
                                                              automobile
                                                              industry clients.
                                                              The supportive
                                                              culture and
                                                              leadership
                                                              genuinely care
                                                              about our
                                                              development,
                                                              making it a place
                                                              where learning and
                                                              growth never stop!
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Sanket
                                                                  Chikhale,
                                                                </strong>
                                                                Marketing
                                                                Technologist
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td align="center"></td>
                                                </tr>
                                                <tr>
                                                  <td height={20} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Welcome Aboard */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={joinees}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              As always, we are happy to grow in
                                              numbers. Last quarter allowed us
                                              to welcome Akash Suryawanshi,
                                              Gauri Chitnis, Raghavendra
                                              Kulkarni, Shreyon Lodh, Amaan
                                              Khan, Rohan Phanshikar, Vedant
                                              Raibole, Juhi Shah, Karan Mudliar,
                                              Preeti Chintal, Soham Bhawar,
                                              Arpita Dhumal, and Jagadeesh
                                              Tirumalasetti.
                                              <br />
                                              <br />
                                              We wish them all a great journey
                                              ahead with Comsense! <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Events and Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        {/* <tr>
                      <td width=580 align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:18px;color:red;line-height:28px;font-weight:700;text-align:center">
                        Comsense Premier League – The Fever Was Back Again!
                      </td>
                    </tr> */}
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Workshop}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                The Machine Learning Company’s
                                                Workshop
                                              </strong>
                                              <br />
                                              An AI workshop was conducted
                                              within Comsense by Saurabh Shahane
                                              (Founder, CEO at The Machine
                                              Learning Company). The aim of the
                                              workshop was to explain different
                                              types of AI systems and software
                                              to the employees. The event also
                                              aimed to unravel a few AI tools
                                              that the employees could
                                              incorporate into their daily
                                              working lives to significantly
                                              enhance their productivity. The
                                              workshop was huge success with all
                                              team participating in it with full
                                              enthusiasm.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Grand Birthday Celebrations
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={BirthdayCelebration}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Birthdays are reasons for special
                                              celebrations. The previous quarter
                                              was fun-filled as we celebrated
                                              birthdays of:
                                              <br />
                                              <br />
                                              Tejaswi Raje, Rutika Bhikule,
                                              Shraddha Kale, Anant Kadam,
                                              Swapnali Anarase, Rishabh
                                              Manchanda, Inderjit Singh,
                                              Shreyash Pole, and Rohan
                                              Phanshikar in <strong>April</strong>
                                              <br />
                                              <br />
                                              Uddhav Solanke, Sumedh Pawaskar,
                                              Tushar Valkunde, Shivkumar Dusad,
                                              Shubham Chordia, Soumy Dubey, and
                                              Suraj Patil in <strong>May</strong>
                                              <br />
                                              <br />
                                              Aniket Neugaonkar, Saurab Patil,
                                              Pravish Rajan, Omkar Gaikwad,
                                              Somnath Bhowmick, Linal Patil,
                                              Radha Kulkarni, Mitra Dwivedi,
                                              Vedant Raibole, Juhi Shah, Karan
                                              Mudliar in <strong>June</strong>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Spiritual Corner */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              {" "}
                                              Spiritual Corner{" "}
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={daji}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />
                                              <a
                                                href="https://heartfulness.org/in/"
                                                target="_blank"
                                                style={{
                                                  color: "#9b9b9b",
                                                  fontFamily: "Open Sans",
                                                  fontSize: 14,
                                                  fontStyle: "normal",
                                                  fontWeight: 700,
                                                  lineHeight: "22px",
                                                  letterSpacing: "-.28px",
                                                  textDecorationLine:
                                                    "underline",
                                                  textAlign: "left !important",
                                                }} rel="noreferrer"
                                              >
                                                More about Heartfulness:
                                                www.heartfulness.org
                                                <br />
                                                <br />
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default June;
